<ng-container *transloco="let t">
  <div id="compact-paginator" class="flex items-center justify-center gap-1 py-3 bg-white border-t border-ld-border">
    <button
      id="compact-paginator-prev"
      type="button"
      class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer bg-transparent border-none disabled:opacity-30 disabled:cursor-not-allowed"
      [disabled]="isFirstPage()"
      (click)="goToPrevious()"
      [attr.aria-label]="t('paginatorPreviousPage')"
    >
      <svg class="w-5 h-5 text-ld-neutral" viewBox="0 0 20 20" fill="none">
        <path
          d="M12.5 15L7.5 10L12.5 5"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <span id="compact-paginator-info" class="font-dm text-sm text-ld-neutral px-3 min-w-[100px] text-center">
      {{ t('paginatorPageOfPages', { current: currentPage(), total: totalPages() }) }}
    </span>

    <button
      id="compact-paginator-next"
      type="button"
      class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer bg-transparent border-none disabled:opacity-30 disabled:cursor-not-allowed"
      [disabled]="isLastPage()"
      (click)="goToNext()"
      [attr.aria-label]="t('paginatorNextPage')"
    >
      <svg class="w-5 h-5 text-ld-neutral" viewBox="0 0 20 20" fill="none">
        <path
          d="M7.5 5L12.5 10L7.5 15"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</ng-container>
